<template>
  <div class="mini-recent-place-card" @click="clickMiniRecentPlaceCard">
    <div class="category-icon-container">
      <img class="category-icon" :src="categoryIconPath !== '' ? categoryIconPath : util.getImagePath('pin_blue@2x.png')" :srcset="categoryIconHdPath !== '' ? `${categoryIconHdPath} 2x` : util.getImageSet('pin_blue')">
      <img class="sent-icon" :src="util.getImagePath('out_gray@2x.png')" :srcset="util.getImageSet('out_gray')" v-if="recentType === 'S'">
      <img class="receive-icon" :src="util.getImagePath('in_orange@2x.png')" :srcset="util.getImageSet('in_orange')" v-if="recentType === 'R'">
      <img class="create-icon" :src="util.getImagePath('create_orange@2x.png')" :srcset="util.getImageSet('create_orange')" v-if="recentType === 'C'">
    </div>
    <div class="detail">
      <span class="name">{{ $i18n.locale === 'th' ? nameTh : nameEn }}</span>
      <PromptPaiSnippetButton :id="code" />
      <span class="contact-name">{{ recentType === 'C' ? createrName : contactName }}</span>
    </div>
    <div class="right-detail">
      <button class="promptpai-icon-button" @click="clickPromptpaiIcon" :class="{clickable: clickable}" v-if="code.length === 8">
        <img :src="util.getImagePath('promptpai_icon@2x.png')" :srcset="util.getImageSet('promptpai_icon')">
      </button>
      <div class="datetime">{{ displayDatetime }}</div>
    </div>
  </div>
</template>

<script>
import PromptPaiSnippetButton from '@/components/PromptPaiSnippetButton.vue'

export default {
  name: 'MiniRecentPlaceCard',
  components: {
    PromptPaiSnippetButton
  },
  props: {
    categoryIconPath: {
      type: String,
      default: ''
    },
    categoryIconHdPath: {
      type: String,
      default: ''
    },
    recentType: {
      type: String,
      default: ''
    },
    code: {
      type: String,
      default: ''
    },
    nameTh: {
      type: String,
      default: ''
    },
    nameEn: {
      type: String,
      default: ''
    },
    contactName: {
      type: String,
      default: ''
    },
    timestamp: {
      type: Number,
      default: ''
    },
    location: {
      type: Object,
      default: undefined
    },
    clickable: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    createrName () {
      var self = this
      var isAuthenticated = JSON.parse(self.getPromptPaiCookies('isAuthenticated'))
      if (isAuthenticated) {
        return JSON.parse(self.getPromptPaiCookies('UserProfile')).display_name
      } else {
        return self.$t('MiniRecentPlaceCard.anonymous')
      }
    },
    displayCode () {
      var self = this
      if (self.code.length === 8) {
        return self.code.substring(0, 4) + ' ' + self.code.substring(4, 8)
      } else {
        return ''
      }
    },
    displayDatetime () {
      var self = this
      var month = [
        {
          th: 'ม.ค.',
          en: 'Jan'
        },
        {
          th: 'ก.พ.',
          en: 'Feb'
        },
        {
          th: 'มี.ค.',
          en: 'Mar'
        },
        {
          th: 'เม.ย.',
          en: 'Apr'
        },
        {
          th: 'พ.ค.',
          en: 'May'
        },
        {
          th: 'มิ.ย.',
          en: 'Jun'
        },
        {
          th: 'ก.ค.',
          en: 'Jul'
        },
        {
          th: 'ส.ค.',
          en: 'Aug'
        },
        {
          th: 'ก.ย.',
          en: 'Sep'
        },
        {
          th: 'ต.ค.',
          en: 'Oct'
        },
        {
          th: 'พ.ย.',
          en: 'Nov'
        },
        {
          th: 'ธ.ค.',
          en: 'Dec'
        }
      ]
      var now = new Date()
      var date = new Date(Number(self.timestamp) * 1000)
      if (Number(date.getFullYear()) < Number(now.getFullYear())) {
        return `${date.getDate()} ${month[date.getMonth()][self.$root.$i18n.locale]} ${`${(Number(date.getFullYear()) + (self.$root.$i18n.locale === 'th' ? 543 : 0))}`.substr(-2)}`
      } else if (Number(date.getDate()) === Number(now.getDate()) && Number(date.getMonth()) === Number(now.getMonth()) && Number(date.getFullYear()) === Number(now.getFullYear())) {
        return `${date.getHours()}:${`0${date.getMinutes()}`.substr(-2)}`
      } else {
        return `${date.getDate()} ${month[date.getMonth()][self.$root.$i18n.locale]}`
      }
    }
  },
  methods: {
    clickMiniRecentPlaceCard () {
      var self = this
      self.$emit('clickMiniRecentPlaceCard', self)
    },
    clickPromptpaiIcon () {
      var self = this
      self.$emit('clickPromptpaiIcon', self)
    }
  }
}
</script>

<style scoped>
  .mini-recent-place-card {
    width: 100%;
    /* height: 60px; */
    display: flex;
    flex-direction: row;
    align-items: flex-start;
  }

  .mini-place-card.clickable:hover {
    background: rgb(227, 227, 227);
  }

  .category-icon-container {
    width: 24px;
    height: 24px;
    margin: auto 16px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
  }

  img.category-icon {
    max-width: 24px;
    max-height: 24px;
  }

  .sent-icon,
  .receive-icon {
    position: absolute;
    width: 32px;
    height: 32px;
    top: 12px;
    left: 6px;
  }

  .create-icon {
    position: absolute;
    width: 16px;
    height: 16px;
    top: 16px;
    left: 16px;
  }

  .detail {
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: calc(100% - 56px - 60px);
    /* overflow: hidden; */
    /* padding-top: 4px; */
    box-sizing: border-box;
  }

  .detail > .name {
    font-weight: 100px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 1.75;
    text-indent: 2px;
  }

  .detail > .contact-name {
    color: rgb(120, 120, 120);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-top: 4px;
    font-size: 14px;
  }

  .right-detail {
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 60px;
    overflow: hidden;
    box-sizing: border-box;
  }

  /* .sent-icon,
  .receive-icon {
    width: 32px;
    height: 32px;
    margin: 6px 15px 6px 15px;
  } */

  button.promptpai-icon-button {
    width: 32px;
    height: 32px;
    padding: 0px;
    margin: 6px 15px 6px 15px;
    background-color: transparent;
    border: none;
    cursor: default;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  button.promptpai-icon-button.clickable {
    cursor: pointer;
  }

  .promptpai.icon > img {
    width: 32px;
    height: 32px;
  }

  .datetime {
    color: rgb(120, 120, 120);
    text-align: center;
    font-size: 14px;
  }
</style>



// WEBPACK FOOTER //
// src/components/MiniRecentPlaceCard.vue